export default __webpack_public_path__ + "static/media/table-settings.ada144aa.svg";